<template>
  <div class="stats-widget">
    <line-chart
      class="graph pb-2"
      v-if="dataCollection"
      :chart-data="dataCollection"
    />
    <div class="separator"></div>
    <div class="actions py-1 d-flex justify-space-between align-center">
      <span class="period">Últimas 24 horas</span>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { IStat } from '../../interfaces/IStat';
  import LineChart from './LineChart';
  @Component({
    components: { LineChart },
  })
  export default class StatsWidget extends Vue {
    @Prop() options: {
      label: string;
      from: Date;
      to: Date;
      interval: 'hour' | 'day';
    };
    @Prop() stats: IStat[];
    dataCollection = null;

    async created() {
      this.update();
    }

    @Watch('stats')
    onStatsChanged() {
      this.update();
    }

    @Watch('options', { deep: true })
    onOptionsChanged() {
      this.update();
    }

    get statsByHour() {
      const statsByHour: { [time: number]: IStat } = {};

      if (this.stats) {
        for (const stat of this.stats) {
          statsByHour[stat.hour.getTime()] = stat;
        }
      }

      return statsByHour;
    }

    update() {
      if (!this.stats || !this.options) return;

      const labels = [];
      const data = [];

      switch (this.options.interval) {
        case 'hour':
          const from = new Date(this.options.from);
          from.setMinutes(0, 0, 0);
          const to = new Date(this.options.to);
          to.setMinutes(0, 0, 0);
          const fromMs = from.getTime(),
            toMs = to.getTime();

          for (let h = fromMs; h <= toMs; h += 1000 * 60 * 60) {
            const hour = new Date(h);

            const val = this.statsByHour[h]?.value || 0;
            data.push(val);

            labels.push(
              `${hour.getHours()}` + (h == fromMs || h == toMs ? 'hs' : '')
            );
          }
          break;
      }

      this.dataCollection = {
        labels,
        datasets: [
          {
            label: this.options.label,
            backgroundColor: '#45a5f5',
            borderColor: '#45a5f5',
            data: data,
            fill: false,
            cubicInterpolationMode: 'monotone',
            // lineTension: 0 // Linear
          } /*, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }*/,
        ],
      };
    }

    requestUpdate() {
      this.$emit('refresh', this.options);
    }
  }
</script>
